import React, { useContext } from 'react';
import { LogoWithText, StaticContext } from '@sm/webassets';
import { Box } from '@wds/box';
import { Link } from '@wds/link';
import { Button } from '@wds/button';
import { subdomainUri } from '../AppDirNavHeader';
import useStyles from './styles';

const NavHeader = () => {
  const {
    environment: { domain, subdomain, tld },
  } = useContext(StaticContext);
  const { navHeader } = useStyles();

  return (
    <Box className={navHeader} display="grid" gridTemplateColumns="180px auto 200px" px={8} py={4}>
      <Box display="flex" flexJustify="space-around" flexAlign="center">
        <LogoWithText color="alt" />
      </Box>
      <Box display="flex" flexJustify="center" flexAlign="center" gap={6}>
        <Box>
          <Link underline={false} color="light" href="/apps/v2">
            App Directory
          </Link>
        </Box>
        <Box>
          <Link underline={false} color="light" href={subdomainUri('developer', domain, subdomain, tld)}>
            Develop
          </Link>
        </Box>
        <Box>
          <Link underline={false} color="light" href="https://www.surveymonkey.com/mp/partner-program/">
            Partner
          </Link>
        </Box>
      </Box>
      <Box display="flex" flexJustify="flex-end" flexAlign="center" gap={6}>
        <Box>
          <Link underline={false} color="light" href="/user/sign-in">
            Sign In
          </Link>
        </Box>
        <Box>
          <Button color="secondary" variant="ghost" href="/user/sign-up">
            Sign Up
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NavHeader;
